import { Icon } from 'antd';
import * as React from 'react';
const ErrorSvg = (props: any) => (
<svg {...props} viewBox="0 0 104 104">
    <g id="Unauthorized" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Organization-not-found" transform="translate(-632.000000, -288.000000)">
            <g id="Group-2" transform="translate(421.000000, 288.000000)">
                <g id="Group" transform="translate(211.000000, 0.000000)">
                    <circle id="Oval" fill="#F35A4E" cx="52" cy="52" r="52"></circle>
                    {/* tslint:disable */}
                    <g transform="translate(45.000000, 22.000000)" fill="#FFFFFF" fillRule="nonzero" id="Path">
                        <path d="M12.5205912,54.8546739 C12.5205912,57.6966739 10.1628639,60.0000072 7.25627297,60.0000072 C4.34900024,60.0000072 1.99331842,57.6966739 1.99331842,54.8546739 C1.99331842,52.0100072 4.34900024,49.7073406 7.25627297,49.7073406 C10.1628639,49.7080072 12.5205912,52.0106739 12.5205912,54.8546739 L12.5205912,54.8546739 Z"></path>
                        <path d="M14.4876366,6.84334056 C14.3574093,5.38067389 13.781273,4.00334056 12.9030912,2.87334056 C11.5605912,1.14667389 9.50968206,-0.00332610616 7.25695479,0 C5.0710457,-0.00265943949 3.0760457,1.07934056 1.73286388,2.72000723 C0.785136606,3.87734056 0.161954788,5.31334056 0.0255911519,6.84334056 C-0.0105452117,7.24734056 -0.00645430262,7.68534056 0.0255911519,8.07800723 L3.01945479,41.6073406 C3.11013661,42.6193406 3.56422752,43.5133406 4.24400024,44.1786739 C5.02127297,44.9393406 6.09309115,45.4013406 7.25695479,45.4000108 C8.30422752,45.4013406 9.27718206,45.0266739 10.0271821,44.3980072 C10.8405912,43.7166739 11.3928639,42.7340072 11.493773,41.6066739 L14.4876366,8.07734056 C14.5203639,7.68467389 14.523773,7.24734056 14.4876366,6.84334056 Z"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>);
const ErrorIcon  = props => (
  <Icon component={(innerProps) => {
    return ErrorSvg(Object.assign({}, innerProps, props));
  }}></Icon>
);

export default ErrorIcon;
